import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6080da04"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex h-[66px] justify-between p-5 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Users")
  ])
], -1))
const _hoisted_2 = { class: "flex gap-2 justify-between overflow-x-auto px-5 py-3" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+ Add User", -1))
const _hoisted_5 = { class: "flex gap-2 sm:absolute right-4" }
const _hoisted_6 = { class: "flex flex-col gap-2 overflow-x-auto p-5" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"box-head-blank justify-between\" data-v-6080da04><div class=\"flex gap-4 items-center\" data-v-6080da04><div class=\"h-4 w-8\" data-v-6080da04></div><div class=\"w-44\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Name</span></div><div class=\"w-44\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Email</span></div><div class=\"w-32\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Phone</span></div><div class=\"flex justify-center w-24\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Role</span></div><div class=\"flex justify-center w-24\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Creation Date</span></div><div class=\"flex justify-center w-24\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Orders</span></div><div class=\"flex justify-center w-24\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Total Spend</span></div></div><div class=\"flex gap-4 justify-end\" data-v-6080da04><div class=\"flex justify-center w-36\" data-v-6080da04><span class=\"text-order\" data-v-6080da04>Status</span></div><div class=\"flex justify-end w-9\" data-v-6080da04></div></div></div>", 1)
const _hoisted_8 = { class: "flex gap-4 items-center" }
const _hoisted_9 = { class: "w-8" }
const _hoisted_10 = { class: "avatar uppercase" }
const _hoisted_11 = { class: "w-44" }
const _hoisted_12 = { class: "text-title" }
const _hoisted_13 = { class: "w-44" }
const _hoisted_14 = { class: "text truncate" }
const _hoisted_15 = { class: "w-32" }
const _hoisted_16 = { class: "text truncate" }
const _hoisted_17 = { class: "flex justify-center w-24" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "flex justify-center w-24" }
const _hoisted_20 = { class: "text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "12")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "20,00 €")
], -1))
const _hoisted_23 = { class: "flex gap-4 items-center" }
const _hoisted_24 = { class: "flex justify-center w-36" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-end w-9\" data-v-6080da04><a href=\"#\" class=\"button-nav\" data-v-6080da04><svg width=\"14\" height=\"14\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6080da04><path d=\"M7.0636 11.1392H11.4782\" stroke=\"#515151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6080da04></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.47478 1.00552C6.94691 0.441251 7.79563 0.35851 8.3716 0.821044C8.40345 0.846138 9.42663 1.64099 9.42663 1.64099C10.0594 2.0235 10.256 2.83666 9.86484 3.45722C9.84407 3.49045 4.05943 10.7262 4.05943 10.7262C3.86698 10.9663 3.57484 11.108 3.26263 11.1114L1.04735 11.1392L0.548225 9.02662C0.478306 8.72956 0.548225 8.41759 0.740677 8.17751L6.47478 1.00552Z\" stroke=\"#515151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6080da04></path><path d=\"M5.40393 2.34833L8.72269 4.89701\" stroke=\"#515151\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-6080da04></path></svg></a></div>", 1)
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-2 items-center justify-end p-3\" data-v-6080da04><div class=\"button-pagination\" data-v-6080da04><span data-v-6080da04>Prev</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>1</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>2</span></div><div class=\"button-pagination-page-active\" data-v-6080da04><span data-v-6080da04>3</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>4</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>5</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>...</span></div><div class=\"button-pagination-page-inactive\" data-v-6080da04><span data-v-6080da04>20</span></div><div class=\"button-pagination\" data-v-6080da04><span data-v-6080da04>Next</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/users/add",
          class: "button"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AutoComplete, {
          "return-by": "'firstName'",
          "track-by": "firstName",
          "filter-by": "firstName",
          "show-by": "firstName",
          placeholder: "Name",
          "on-change": _ctx.changeStatus,
          items: _ctx.users
        }, null, 8, ["on-change", "items"]),
        _createVNode(_component_AutoComplete, {
          class: "lowercase",
          "return-by": "'email'",
          "track-by": "email",
          "filter-by": "email",
          "show-by": "email",
          placeholder: "Email",
          "on-change": _ctx.changeStatus,
          items: _ctx.users
        }, null, 8, ["on-change", "items"]),
        _createVNode(_component_AutoComplete, {
          class: "lowercase",
          "return-by": "'phone'",
          "track-by": "phone",
          "filter-by": "phone",
          "show-by": "phone",
          placeholder: "Phone",
          "on-change": _ctx.changeStatus,
          items: _ctx.users
        }, null, 8, ["on-change", "items"]),
        _createVNode(_component_AutoComplete, {
          class: "lowercase",
          "return-by": "'name'",
          "track-by": "name",
          "filter-by": "name",
          "show-by": "name",
          placeholder: "Role",
          "on-change": _ctx.changeStatus,
          items: [{ name: 'admin' }, { name: 'customer' }, { name: 'owner' }]
        }, null, 8, ["on-change"]),
        _createVNode(_component_AutoComplete, {
          "return-by": "'value'",
          "track-by": "value",
          "filter-by": "value",
          "show-by": "value",
          placeholder: "Status",
          modelValue: _ctx.filter.status,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.status) = $event)),
          "on-change": _ctx.changeStatus,
          items: [
          { name: 'Active', value: 'active' },
          { name: 'Inactive', value: 'inactive' },
          { name: 'Pending', value: 'pending' },
        ]
        }, null, 8, ["modelValue", "on-change"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users as any[], (user) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box-blank justify-between min-w-max",
          key: user?.id
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(user?.firstName?.charAt(0)) + _toDisplayString(user?.lastName?.charAt(0)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(user?.firstName) + " " + _toDisplayString(user?.lastName), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(user?.email), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString(user?.phone), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, _toDisplayString(user?.isSuper ? "Admin" : "User"), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.convertDate(user?.createdAt)), 1)
            ]),
            _hoisted_21,
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_AutoComplete, {
                placeholder: "Status",
                modelValue: user.status,
                "onUpdate:modelValue": ($event: any) => ((user.status) = $event),
                "on-change": _ctx.changeStatus,
                items: ['Active', 'Inactive']
              }, null, 8, ["modelValue", "onUpdate:modelValue", "on-change"])
            ]),
            _hoisted_25
          ])
        ]))
      }), 128)),
      _hoisted_26
    ])
  ], 64))
}